import React from 'react'
import RasterLayer from './RasterLayer'

const IceDriftDeformationVorticity = () => {
  return (
    <RasterLayer
      id='IceDriftDeformationVorticity'
      authId='IceDrift'
      />
  )
}

export default IceDriftDeformationVorticity



// WEBPACK FOOTER //
// ./src/layers/IceDriftDeformationVorticity.js